/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { TUMPeriod, TUMPeriod$inboundSchema } from "./tumperiod.js";

export type TokensUnderManagement = {
  /**
   * Email address to notify on TUM threshold events. Only populated for platform admins.
   */
  alertEmail?: string | undefined;
  /**
   * Day of month (1-31) the billing cycle starts, at 00:00 UTC
   */
  billingCycleAnchorDay: number;
  /**
   * TUM usage per billing cycle for the trailing cycles, oldest first. The last entry is the active cycle.
   */
  history: Array<TUMPeriod>;
  /**
   * The contracted monthly tokens under management limit, if one has been configured
   */
  monthlyTokenLimit?: number | undefined;
  /**
   * End of the active billing cycle (exclusive)
   */
  periodEnd: Date;
  /**
   * Start of the active billing cycle
   */
  periodStart: Date;
  /**
   * Tokens under management consumed during the active billing cycle
   */
  tokens: number;
  /**
   * The contracted tunneled MCP server source cap, if one has been configured
   */
  tunneledMcpServerLimit?: number | undefined;
};

/** @internal */
export const TokensUnderManagement$inboundSchema: z.ZodMiniType<
  TokensUnderManagement,
  unknown
> = z.pipe(
  z.object({
    alert_email: z.optional(z.string()),
    billing_cycle_anchor_day: z.int(),
    history: z.array(TUMPeriod$inboundSchema),
    monthly_token_limit: z.optional(z.int()),
    period_end: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    period_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    tokens: z.int(),
    tunneled_mcp_server_limit: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "alert_email": "alertEmail",
      "billing_cycle_anchor_day": "billingCycleAnchorDay",
      "monthly_token_limit": "monthlyTokenLimit",
      "period_end": "periodEnd",
      "period_start": "periodStart",
      "tunneled_mcp_server_limit": "tunneledMcpServerLimit",
    });
  }),
);

export function tokensUnderManagementFromJSON(
  jsonString: string,
): SafeParseResult<TokensUnderManagement, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TokensUnderManagement$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TokensUnderManagement' from JSON`,
  );
}
